export default __webpack_public_path__ + "static/race-day-virtual-square-7dd7010fa89daa3dd401a89775bb0df5.png";